<template lang="pug">
    div
        navbar(:opaque="true")
        section
            div.container
                div.section.privacy-banner.has-text-centered
                    h1.is-size-2.is-uppercase.has-text-weight-light {{ $t('page_11.title') }}
                    h2.privacy-subtitle.is-size-15.is-uppercase {{ $t('page_11.subtitle') }}

                div
                    div.policy-item(v-for="i in $t('page_11.blocks')")
                        div.columns
                            div.column.is-4
                                h1.policy-item-title.is-size-13.is-uppercase.has-text-weight-bold {{ i.title }}
                            div.column.is-8
                                p(v-html="i.text")
        the-footer
</template>

<script>
import Navbar from '@/components/the-navbar'
import TheFooter from '@/components/the-footer'

export default {
    name: 'privacy-policy',
    components: { Navbar, TheFooter }
}
</script>

<style lang="stylus" scoped>
.privacy-banner
    padding-top 180px
    padding-bottom 100px

.privacy-subtitle
    line-height 30px
    letter-spacing 1px

.policy-item-title
    letter-spacing 1px
    line-height 26px

.policy-item
    border-top 1px solid #1d3763
    padding 35px 0

</style>
